import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './AccountPage.scss';
import MyPersonalInformations from './components/MyPersonalInformations/MyPersonalInformations';
import MyTrainings from './components/MyTrainings/MyTrainings';
import Loading from '../../../components/Loading/Loading';
import { strapiTrainingService } from '../../../services/api/strapiTraining';
import { useAuth } from '../../../contexts/AuthContext';
import strapiClient from '../../../services/strapi/config';

const AccountPage = ({setNotification}) => {
    const navigate = useNavigate();
    const { user, isAuthenticated } = useAuth();
    const [userTrainings, setUserTrainings] = useState(null);
    const [hasActivePlans, setHasActivePlans] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    useEffect(() => {
        if (!isAuthenticated) {
            navigate('/connexion');
        }
    }, [isAuthenticated, navigate]);

    useEffect(() => {
        const fetchUserTrainingsData = async () => {
            try {
                const token = localStorage.getItem('strapiToken');
                if (!token) {
                    navigate('/connexion');
                    return;
                }
                setLoading(true);

                const [trainings, plansResponse] = await Promise.all([
                    strapiTrainingService.getUserTrainings(),
                    strapiClient.get('/api/purchases/my-installment-plans', {
                        headers: { Authorization: `Bearer ${token}` }
                    }).catch(() => ({ data: { data: [] } }))
                ]);

                setUserTrainings(trainings.data);
                const plans = plansResponse.data?.data || [];
                setHasActivePlans(plans.some(p => p.status === 'active'));
                setError(null);
            } catch (error) {
                setError(error.message);
                if (error.message.includes('401') || error.message.includes('403')) {
                    localStorage.removeItem('strapiToken');
                    navigate('/connexion');
                }
            } finally {
                setLoading(false);
            }
        };

        fetchUserTrainingsData();
    }, [navigate]);

    useEffect(() => {
        if (sessionStorage.getItem('profileUpdateMessage')) {
            setNotification({
                message: sessionStorage.getItem('profileUpdateMessage'),
                type: 'success'
            });
            sessionStorage.removeItem('profileUpdateMessage');
        }
        if (sessionStorage.getItem('changePasswordMessage')) {
            setNotification({
                message: sessionStorage.getItem('changePasswordMessage'),
                type: 'success'
            });
            sessionStorage.removeItem('changePasswordMessage');
        }
    }, []);

    return (
        <div className="account-page">
            <Helmet>
                <title>Mon compte | Soutien émotionnel des mamans | Grandir et s'élever ensemble</title>
                <meta name="description" content="Soutien émotionnel & aide à la parentalité consciente - Gérez votre compte et accédez à vos formations" />
            </Helmet>
            {
                loading ? <Loading /> :
                    <div className="account-page__content">
                        <MyPersonalInformations user={user} loading={loading} hasActivePlans={hasActivePlans} />
                        <MyTrainings userTrainings={userTrainings} />
                    </div>
            }
        </div>
    );
};

export default AccountPage;